<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-25 17:18:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/search/index.vue
-->
<template>
  <div class="search">
    <search-title-bar @changeWords="changeWords" :keyValue="keyWords" />
    <div class="line_height"></div>
    <div v-if="!keyWords.trim()">
      <!-- 历史搜索 -->
      <history-list
        :searchKeys="searchKeys"
        @deleteHis="deleteHis"
        @clickHistoryItem="clickHistoryItem"
      />
      <!-- 搜索发现 -->
      <search-find @clickHistoryItem="clickHistoryItem" />
    </div>
    <!-- 搜索商品无结果 -->
    <search-none
      v-if="keyWords.trim() && searchProductList.rows.length === 0"
      :keyWords="keyWords"
    />
    <!-- 搜索商品出结果 -->
    <search-product-list
      v-if="
        keyWords.trim() &&
          !lookAllProduct &&
          searchProductList.rows.length !== 0
      "
      @lookAll="lookAll"
      @goDetail="goDetail"
    />
    <!-- 查看所有搜索结果 -->
    <div v-if="lookAllProduct">
      <!-- 新品切换 -->
      <div class="switch_fixed">
        <slot-switch @switchCate="switchCate" />
      </div>
      <!-- 底部商品 -->
      <div class="product_top">
        <recommend
          :productCon="searchProductList"
          :loadings="loadings"
          @onRefresh="onRefresh"
          @onLoad="onLoad"
          @showPoster="showPosters"
        />
      </div>
    </div>
    <!--  猜你喜欢-->
    <!-- <you-love v-if="(!keyWords && isList) || !keyWords" /> -->
    <!-- 海报 -->
    <poster
      v-if="showPoster"
      :show="showPoster"
      :posterItem="posterItem"
      @closePoster="closePoster"
      @openShare="openShare"
    />
    <share-mask v-if="showShareMask" @hideMask="hideMask" />
  </div>
</template>
<script>
import NativeShare from "nativeshare";
const SearchTitleBar = () =>
  import("./components/SearchTitleBar").then(m => m.default || m);
const HistoryList = () =>
  import("./components/HistoryList").then(m => m.default || m);
const SearchFind = () =>
  import("./components/SearchFind").then(m => m.default || m);
// const YouLove = () => import("./components/YouLove").then(m => m.default || m);
const SearchNone = () =>
  import("./components/SearchNone").then(m => m.default || m);
const SearchProductList = () =>
  import("./components/SearchProductList").then(m => m.default || m);
const Recommend = () =>
  import("@/components/Recommend").then(m => m.default || m);
const SlotSwitch = () =>
  import("../category/firstproduct/components/SlotSwitch").then(
    m => m.default || m
  );
const ShareMask = () =>
  import("../mine/cardvoucher/components/ShareMask").then(m => m.default || m);
const Poster = () =>
  import("../product/detail/components/Poster").then(m => m.default || m);
export default {
  name: "Search",
  components: {
    SearchTitleBar,
    HistoryList,
    SearchFind,
    // YouLove,
    SearchNone,
    SearchProductList,
    Recommend,
    SlotSwitch,
    ShareMask,
    Poster
  },
  data() {
    return {
      lookAllProduct: false,
      keyWords: "",
      isList: false,
      loadings: false,
      showShareMask: false,
      showPoster: false
    };
  },
  computed: {
    searchProductList() {
      return this.$store.getters.searchProductList;
    },
    // searchFoundList() {
    //   return this.$store.getters.searchFoundList;
    // },
    searchKeys() {
      const searchKeys = this.$store.getters.searchKeys.filter(
        item => item !== null && item !== ""
      );
      return searchKeys;
    },
    getSimpleUserInfo() {
      return this.$store.getters.getSimpleUserInfo;
    }
  },
  watch: {
    searchProductList: {
      handler(old, newValue) {
        console.log(old, newValue);
      },
      deep: true
    }
  },
  created() {
    this.getFoundData();
    this.getUserData();
  },
  mounted() {
    const str = localStorage.SEARCH_KEYS;
    if (str && str !== null) {
      this.$store.dispatch("product/initSearchKeys", {
        keys: JSON.parse(str),
        callback: () => {}
      });
    }
    // console.log(this.searchKeys, "searchKeys");
    // this.getFoundData();
    // console.log(this.searchFoundList, 11111);
  },
  methods: {
    getData(params) {
      // findClientRetailSpuByParam
      this.$store
        .dispatch("product/findClientRetailSpuByParam", {
          params
        })
        .then(() => {
          // this.$store.dispatch("product/setSearchKeys", {
          //   keywords: this.keyWords.trim()
          // });
          // console.log(this.searchKeys, "searchKeys");
        })
        .catch(() => {});
    },
    // 获取搜索发现数据
    getFoundData() {
      // console.log(6666);
      // searchFoundList
      this.$store
        .dispatch("product/searchFoundList")
        .then(() => {
          // console.log(222);
        })
        .catch(() => {});
    },
    // 海报获取用户数据
    getUserData() {
      this.$store
        .dispatch("mine/getSimpleUserInfo")
        .then(() => {})
        .catch(() => {});
    },
    // 刷新
    onRefresh() {
      const params = {
        keywords: this.keyWords.trim(),
        pageNo: 1,
        pageSize: 20,
        slug: this.slug
      };
      this.getData(params);
      this.getFoundData();
      this.getUserData();
    },
    onLoad() {
      // console.log("上拉进行中");
      this.loadings = false;
      if (
        this.searchProductList.hasNextPage &&
        this.searchProductList.pageNo <= this.searchProductList.pageCount
      ) {
        this.loadings = true;
        const pageIndex = this.searchProductList.pageNo + 1;
        const params = {
          keywords: this.keyWords.trim(),
          pageNo: pageIndex,
          pageSize: 20,
          slug: this.slug
        };
        this.getData(params);
        // console.log("上拉完毕");
      }
    },
    // 搜索框输入字段
    changeWords(value) {
      this.keyWords = value;
      this.isList = true;
      if (this.keyWords.trim()) {
        const params = {
          keywords: value.trim(),
          pageNo: 1,
          pageSize: 20,
          slug: this.slug
        };
        this.getData(params);
      } else {
        this.lookAllProduct = false;
      }
    },
    // 查看全部
    lookAll() {
      this.lookAllProduct = true;
      this.$store.dispatch("product/setSearchKeys", {
        keywords: this.keyWords.trim()
      });
    },
    goDetail(id) {
      this.$router.push({
        path: "/product/detail",
        query: {
          id
        }
      });
      this.$store.dispatch("product/setSearchKeys", {
        keywords: this.keyWords.trim()
      });
    },
    // 切换标签
    switchTag(index) {
      this.tagIndex = index;
    },
    // 删除历史
    deleteHis() {
      // console.log("删除历史");
      if (localStorage.SEARCH_KEYS) {
        localStorage.removeItem("SEARCH_KEYS");
        this.$store.dispatch("product/initSearchKeys", {
          keys: [],
          callback: () => {}
        });
      }
    },
    // 历史点击搜索
    clickHistoryItem(keyWords) {
      const params = {
        keywords: keyWords.trim(),
        pageNo: 1,
        pageSize: 20,
        slug: this.slug
      };
      this.getData(params);
      this.keyWords = keyWords;
      this.isList = true;
    },
    // 查看全部排序
    switchCate(index, newSlot, priceSlot) {
      const params = {
        keywords: this.keyWords.trim(),
        pageNo: 1,
        pageSize: 20,
        slug: this.slug
        // sort: newSlot ? "gmtCreate" : priceSlot ? "storePrice" : "",
        // direction: "desc" // direction:desc/asc
      };
      if (newSlot) {
        params.sort = "gmtCreate";
        params.direction = newSlot;
      }
      if (priceSlot) {
        params.sort = "gmtCreate";
        params.direction = priceSlot;
      }
      this.getData(params);
    },
    showPosters(productDetail) {
      this.posterItem = productDetail;
      this.showPoster = true;
    },
    closePoster() {
      this.showPoster = false;
    },
    hideMask() {
      this.showShareMask = false;
    },
    isWechatBrowser() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      return isWeixin;
    },
    openShare() {
      // console.log(typeof NativeShare);
      // console.log(NativeShare, 88888);
      if (typeof NativeShare !== "undefined") {
        // console.log(111);
        if (this.isWechatBrowser()) {
          // console.log(222);
          this.showPoster = false;
          this.showShareMask = true;
        } else {
          this.$toast("需要在微信浏览器分享哦！");
        }
      } else {
        this.showPoster = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.search {
  background: #fff;
  .line_height {
    height: 48px;
  }
  .switch_fixed /deep/ .two_switch {
    margin-top: 0;
  }
  .switch_fixed {
    position: fixed;
    top: 48px;
    left: 0;
    right: 0;
    z-index: 99;
    box-shadow: 0px 3px 6px -3px rgba(193, 200, 207, 0.5);
  }
  .product_top {
    margin-top: 74px;
  }
}
</style>
